import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import './Apply.css';

const JOTFORM_ID = '262285096628063';

const Apply = () => {
  const embedRef = useRef(null);

  useEffect(() => {
    const container = embedRef.current;
    if (!container) return;
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://www.jotform.com/jsform/${JOTFORM_ID}`;
    container.appendChild(script);
    return () => {
      container.innerHTML = '';
    };
  }, []);

  return (
    <div className="apply-page">
      <div className="apply-container">
        <motion.div
          className="apply-header"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Link to="/" className="back-link" data-testid="apply-back-link">
            <ArrowLeft size={20} />
            Back to Home
          </Link>
          <h1>Application Form</h1>
          <p>
            Complete this application to begin your journey with New Level
            Transition Homes. All information is confidential.
          </p>
        </motion.div>

        <motion.div
          className="jotform-embed"
          data-testid="jotform-embed"
          ref={embedRef}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        />
      </div>
    </div>
  );
};

export default Apply;
